// extracted by mini-css-extract-plugin
export default {"eventDetailShareCard":"EventDetails_eventDetailShareCard__TWYb4","eventDetailShare":"EventDetails_eventDetailShare__pLpF8"};